export default __webpack_public_path__ + "static/accents-role-dont-785fcaa75bc9f62fe30b5fcec97d543e1dd10064faf8853eb70abf4f192e2843.png";